export function formatUserName({ firstName, lastName } = {}) {
  return [firstName, lastName]
    .map((p) => String(p || "").trim())
    .filter(Boolean)
    .join(" ");
}
